import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const getRolesAndPermissionsService = async() => {
    const res = await requestInstance.get(`${env}${API_ENDPOINT.rolesAndPermissions.rolesAndPermissionsApi+"?type=B2B"}`)
    .catch((err) => err.response);
    return setCurrentUser(res);
  }

export const getSupplierRolesApi = async(data) => { 
    const res = await requestInstance.get(`${env}${API_ENDPOINT.rolesAndPermissions.supplierRolesApi+ "?roleType="+data?.role+"&businessType="+data?.businessType}`)
    .catch((err) => err.response);
    return setCurrentUser(res);
  }